import Layout from '@/layout'

const minipUserRouter = {
  path: '/minip/user',
  component: Layout,
  name: 'MinipUser',
  meta: {
    title: '小程序用户管理',
    icon: 'el-icon-user-solid',
    roles: ['root']
  },
  children: [
    {
      path: 'access_audit',
      name: 'MinipAccessAudit',
      component: () => import('@/views/minip/user/accessAudit'),
      meta: { title: '小程序质保权限审核', icon: 'el-icon-s-check', roles: ['root'], noCache: false }
    }
  ]
}

export default minipUserRouter
